import React, { type ReactNode } from "react";

import { getAssetUrl } from "ee/utils/airgapHelpers";
import LeftSideContent from "./LeftSideContent";
import { getAppsmithConfigs } from "ee/configs";
import { useIsMobileDevice } from "utils/hooks/useDeviceDetect";
import styled from "styled-components";

interface ContainerProps {
  title: string;
  subtitle?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  disabledLoginForm?: boolean;
  testId?: string;
  activeTab?: string;
  setActiveTab?: React.Dispatch<React.SetStateAction<string>>;
  tabs?: { key: string; title: ReactNode }[];
  showFooterTip?: boolean;
}

const ContainerWrapper = styled.div`
  a {
    span {
      font-weight: 500;
    }
  }
`;

const BoxWrapper = styled.div<{ isMobileView: boolean }>`
  // box-shadow: 0px 1px 20px 0px rgba(76, 86, 100, 0.11);
  border-radius: var(--ads-v2-border-radius);
  background: #09041a99;
  display: flex;
  flex-direction: column;
  gap: var(--ads-v2-spaces-5);
  padding: 40px;
  backdrop-filter: blur(300px);

  ${({ isMobileView }) =>
    isMobileView ? "border: 1px solid var(--ads-v2-color-border);" : ""};
`;

function Container(props: ContainerProps) {
  const { children, footer, subtitle, testId, title } = props;
  const { cloudHosting } = getAppsmithConfigs();
  const isMobileDevice = useIsMobileDevice();

  return (
    <ContainerWrapper
      className={`gap-14 my-auto flex flex-col items-center justify-center min-w-min`}
      data-testid={testId}
    >
      {cloudHosting && !isMobileDevice && <LeftSideContent />}
      <BoxWrapper
        className={`t--login-container ${
          isMobileDevice ? "w-full" : "w-[min(500px,80%)]"
        }`}
        isMobileView={isMobileDevice}
      >
        {!isMobileDevice && (
          <img
            className="w-fit h-14 mb-4"
            src={getAssetUrl("/static/img/appsmith-logo.svg")}
          />
        )}
        <div className={`flex flex-col gap-4`}>
          <div className="flex flex-col gap-2">
            <h1 className="text-2xl font-semibold text-white">{title}</h1>
            {subtitle && <p className="text-white/50">{subtitle}</p>}
          </div>

          {props?.tabs && (
            <div className="w-full flex items-center gap-8 uppercase -mb-4 mt-2">
              {props?.tabs?.map(({ key, title }) => (
                <div
                  className={`w-fit cursor-pointer hover:text-primary-500 pb-3 ${props?.activeTab === key ? "text-primary-500 border-b border-primary-500" : "text-[#B3BFCB]"}`}
                  key={key}
                  onClick={() => props.setActiveTab?.(key)}
                >
                  {title}
                </div>
              ))}
            </div>
          )}

          <div className="w-full text-lg h-px mb-2 bg-white/10"></div>

          {children}
          {footer}
        </div>
      </BoxWrapper>
      {props?.showFooterTip && (
        <div
          className={`max-w-full text-center break-words text-[#96A6B6] text-sm  ${
            isMobileDevice ? "w-full" : "w-[min(480px,80%)]"
          }`}
        >
          This platform/application is developed using the Appsmith open-source
          low-code tool. Thanks to the Appsmith team and the open-source
          community for their support.
        </div>
      )}
    </ContainerWrapper>
  );
}

export default Container;
